// extracted by mini-css-extract-plugin
export var link = "header-user-module--link--Ql9OA";
export var root = "header-user-module--root--riWX3";